import React, { useEffect, useRef, useState } from 'react';
import '../landing.css';
import splashScreen from '../img/Purple-Clouds-Next-Stop-Animation_v2.gif';
import splashScreenMobile from '../img/Purple-Clouds-Next-Stop-Animation_Mobile_v2.gif';
import { NavLink, useNavigate } from 'react-router-dom';
import MediaComponent from '../components/landingVideo';
import '../FadeOutDiv.css';
import logo from '../img/Air NZ Logo Dark.png';
import alliance from '../img/star_logo (1).png';

const Landing = () => {

  const [visible, setVisible] = useState(true);
  let navState = { from: 'landing' }
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add('landing-page');
    return () => {
      document.body.classList.remove('landing-page');
    }
  })

  const transitionElement = useRef(null)
  const initiateTransitionOut = () => {
    transitionElement.current.classList.add('grow-in-transition')

    setTimeout(() => {
      navigate('/home', { state: navState })
    }, 500)
  }

  return (
    <>
      <div className="landingScreen d-flex flex-wrap justify-content-center align-items-center">
        <span ref={transitionElement} className='landing-transition-element' onClick={() => initiateTransitionOut} />
        <div className={`video-container`}>
          <MediaComponent />
        </div>
        <div className="landing-content absolute text-center">
          <h1 className="full-width">Winter<br />Fly-deas</h1>
          <button className="landing-btn mt-5" onClick={() => initiateTransitionOut()}>
            <a>Take me there</a>
          </button>
        </div>
      </div>
      {/*<div className={`fade-out ${visible ? '' : 'fade-hidden'}`}>
        <img className="desktop splashScreen" src={splashScreen} alt="splash-screen" />
        <img className="mobile splashScreen" src={splashScreenMobile} alt="splash-screen" />
  </div>*/}
      <div className="desktop">
        <div className="landing-nav d-flex align-items-center justify-content-between">
          <div className="alliance"><img src={alliance} /></div>
          <div className="logo"><img src={logo} /></div>
        </div>
      </div>
      <div className="mobile">
        <div className="fixed-top text-center pt-5"><img width="280" src={logo} /></div>
        <div className="fixed-bottom text-center pb-5"><img width="230" src={alliance} /></div>
      </div>
    </>
  );
};
export default Landing;